export const singleOrderAustralia = {
  vat: 'GST',
}
